import React from "react";
import "../mspClientAccessLevel.scss";
import { Dropdown } from "react-bootstrap";
import BufferLoader from "../../Common/BufferLoader";

const RoleItem = ({
  isView = false,
  name = '',
  description='',
  isUpdating = false,
  isDefault = false,
  isDuplicating = false,
  menu = [],
  onItemClick = () => { },
  onMenuItemClick = (e, item) => { },
}) => {
  return (
    <div className="table-data border-item pointer" key={name}>
      <tr className="grid-container-roles">
        <td className="d-flex align-items-center justify-content-between grid-container-children"
          onClick={onItemClick}
        >
          <div className="ml-2 d-flex align-items-center">
            {isUpdating && (
              <div>
                <BufferLoader className={"mr-3"} />
              </div>
            )}
            <div>
              <p className={`user-name m-0 ${isUpdating ? 'f-darkgrey' : ''}`}>{name}</p>
              <p className="user-email m-0">
                {isUpdating ? (isDuplicating ? ("Duplicating...") : ("Deleting...")) : (description)}
              </p>
            </div>
          </div>

          <td className="d-flex align-items-center justify-content-end">
            {isDefault && (<p className="defaultRole">Pre-Defined</p>)}
          </td>
        </td>


        <td className="d-flex align-items-center justify-content-end">
          {!isView && menu !== null && (
            <>
              <Dropdown className="hg-white-dropdown roleMenuDropdown" alignRight>
                <Dropdown.Toggle className="m-0 roleMenuDropdownToggle">
                  <div>
                    <button className="horisontalDotsButton my-button">
                      <img alt="" src="/images/settings-v2/horizontal-dots.svg" />
                    </button>
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu renderOnMount popperConfig={{ strategy: "fixed" }}>
                  <div>
                    {menu?.map((item) => (
                      <div className={`${item.isEnabled === true && "pointer"} roleDropdownItem`} onClick={(e) => { onMenuItemClick(e, item) }}>
                        {item.isEnabled === false && (<img alt="" className="lockerImage" src="/images/settings-v2/locker.svg" />)}
                        <p className={`${item.isEnabled === false && "textGray"}`}>
                          {item.name}
                        </p>
                      </div>
                    ))}
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            </>
          )}
        </td>
      </tr>
    </div>

  );
};

export default RoleItem;
